// Global Instructions Rule Applied!

import { CompanyState } from '../../interfaces/companies.ts'
import { AccountRecordFields } from '../../data_models/account_record.ts'

/**
 * Selector function to find a company by ID in companies.data array
 * Returns the first match found, or undefined if not found
 *
 * Usage:
 * const company = useSelector((state) => selectCompanyById(state, companyId))
 */
export const selectCompanyById = (
  state: { companies: CompanyState },
  companyId: string | number | null | undefined
) => {
  if (!companyId || !state.companies) return undefined

  const companyIdString = companyId.toString()

  const company = state.companies.data.find(
    (company) => company[AccountRecordFields.accounts__id]?.toString() === companyIdString
  )

  return company
}
